module.exports = __webpack_public_path__ + "img/3149954.png";